import script from "./MainInfoListSelect.vue?vue&type=script&setup=true&lang=ts"
export * from "./MainInfoListSelect.vue?vue&type=script&setup=true&lang=ts"

import "./MainInfoListSelect.vue?vue&type=style&index=0&id=10046e44&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10046e44"]])

export default __exports__